import { isDefined } from '../utils';

export const PAY_AMOUNT_MIN = 0.01;
export const PAY_AMOUNT_MAX = 100000;
export const formattedPayAmountMax = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(PAY_AMOUNT_MAX);
export const payAmountValidationMessage = 'Enter the amount of money you receive per check (after tax).';
export const payAmountMaxValidationMessage = `Amount must be less than $${formattedPayAmountMax}.`;

export const payAmountValidations = {
  max: {
    message: payAmountMaxValidationMessage,
    value: PAY_AMOUNT_MAX,
  },
  min: {
    message: payAmountValidationMessage,
    value: PAY_AMOUNT_MIN,
  },
  required: {
    message: payAmountValidationMessage,
    value: true,
  },
};

export const validatePayAmount = (value?: number): true | string => {
  if (!isDefined(value) || Number.isNaN(value) || value <= 0) {
    return payAmountValidationMessage;
  }

  return true;
};
